import React from 'react';
import pt from 'prop-types';
import {getPageData} from '../../sources/CmsSource';
import {useGetPageData} from '../../actions/CmsActions';
import BlankContainer from './Blank.container';
import {extractSlugLocale} from '@epic-core/localization';

const BlankView = ({location = {}}) => {
    const pathname = location.pathname || '';
    const {pageSlug} = extractSlugLocale(pathname);
    const pageData = useGetPageData({cmsUrlPattern: pageSlug});
    return <BlankContainer pageData={pageData || {}} />;
};

BlankView.propTypes = {
    location: pt.object
};

BlankView.getInitialProps = async (match, {locale}, requestedUrl) => {
    const {pageSlug} = extractSlugLocale(requestedUrl);
    const rawPageData = await getPageData(pageSlug);

    //must match structure of StoreProvider
    return {
        cms: {
            [pageSlug]: rawPageData
        }
    };
};

export default BlankView;
